import React, { useEffect, useState } from "react";
import "../Home/Home.css";
import { useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./Instagram.css";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import axios from "axios";
import { FaHeart, FaComment, FaShareAlt, FaBookmark } from "react-icons/fa";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale
);

const Instagram = () => {
  const navigate = useNavigate();

  const handleTabSelect = (eventKey) => {
    switch (eventKey) {
      case "home":
        navigate("/insta");
        break;
      case "profile":
        navigate("/facebook");
        break;
      case "longer-tab":
        navigate("/snapchat");
        break;
      case "contact":
        navigate("/linkedln");
        break;
      default:
        break;
    }
  };
  const [insights, setInsights] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInsights = async () => {
      try {
        const response = await axios.get(
          "http://192.168.0.156:8000/api/v1/insta/insights",
          {
            params: {
              accessToken:
                "EAAOKRz9GUywBOyFk2hnZBoJjbqBfwVT4vMDjGAGEt0aNS4qnLqQvisrcjuZBGspDcWKfmQZBzxqN0y36gM7A6rZBZCGeF53koMrBxXtKZCKaFmmug1GuOanF5V7h5UT1hiJZCvDYEl3Yzd4GVTD3ZBXFZA2xazjvThb2yHC5VRuO5twhN8G3bFNiZAw8JX",
              instagramAccountId: "17841472049965108",
            },
          }
        );
        setInsights(response.data.data.insights);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching insights:", error);
        setLoading(false);
      }
    };

    fetchInsights();
  }, []);

  if (loading) {
    return <div className="spinner"></div>;
  }

  const statsForLineChart = insights.filter(
    (stat) =>
      !["likes", "comments", "shares", "saves"].includes(
        stat.name.toLowerCase()
      )
  );

  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <h2 className="h3 text-dark landing-text-white">Instagram</h2>
        </div>
      </div>

      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 mb-5">
        {insights
          .filter((stat) =>
            ["likes", "comments", "shares", "saves"].includes(
              stat.name.toLowerCase()
            )
          )
          .map((stat, index) => (
            <div key={index} className="col">
              <div
                className={`card rounded-4 p-4 shadow border-0 rounded-lg ${
                  stat.name.toLowerCase() === "likes"
                    ? "bg-primary-light"
                    : stat.name.toLowerCase() === "comments"
                    ? "bg-success-light"
                    : stat.name.toLowerCase() === "shares"
                    ? "bg-warning-light"
                    : stat.name.toLowerCase() === "saves"
                    ? "bg-warning-light"
                    : "bg-info-light"
                }`}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h3 className="h5 text-dark">{stat.title}</h3>

                  <span className="fs-3 text-muted">
                    {stat.name.toLowerCase() === "likes" && <FaHeart />}
                    {stat.name.toLowerCase() === "comments" && <FaComment />}
                    {stat.name.toLowerCase() === "shares" && <FaShareAlt />}
                    {stat.name.toLowerCase() === "saves" && <FaBookmark />}
                  </span>
                </div>
                <p className="h5 text-dark font-weight-bold">
                  {stat.total_value.value}
                </p>
              </div>
            </div>
          ))}
      </div>

      <Tabs
        defaultActiveKey="instagram"
        onSelect={handleTabSelect}
        className="mb-4 border-0 d-none d-lg-block d-lg-flex"
      >
        <Tab
          eventKey="home"
          title={
            <span className="text-decoration-none text-dark landing-text-white">
              Instagram
            </span>
          }
          className="tab-link"
        ></Tab>
        <Tab
          eventKey="profile"
          title={
            <span className="text-decoration-none text-dark landing-text-white">
              Facebook
            </span>
          }
          className="tab-link"
        ></Tab>
        <Tab
          eventKey="longer-tab"
          title={
            <span className="text-decoration-none text-dark landing-text-white">
              Snapchat
            </span>
          }
          className="tab-link"
        ></Tab>
        <Tab
          eventKey="contact"
          title={
            <span className="text-decoration-none text-dark landing-text-white">
              Linkedln
            </span>
          }
          className="tab-link"
        ></Tab>
      </Tabs>

      <div className="container card p-4 shadow border-0 rounded-lg mb-5 bg-light">
        <div className="row mb-4 ">
          {statsForLineChart.map((stat, index) => (
            <div key={index} className="col-md-6">
              <div className="stats-box p-3 border rounded d-flex justify-content-between align-items-center">
                <div className="text-left">
                  <h5>{stat.title}</h5>
                  <p className="mb-3 d-flex justify-content-between align-items-center">
                    {stat.total_value.value}
                  </p>
                </div>
                <div className="graph-container">
                  <Line
                    data={{
                      labels: stat.dates,
                      datasets: [
                        {
                          label: stat.title,
                          data: stat.values,
                          borderColor: "rgba(75,192,192,1)",
                          fill: false,
                        },
                      ],
                    }}
                    options={{
                      responsive: true,
                      maintainAspectRatio: true,
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Instagram;
